<template>
  <FileDialogWrapper @close="$emit('close')">
    <template #header>
      <h3>
        {{ $t("message.common.selectImportColumns") }}
      </h3>
    </template>

    <v-list max-height="400px">
      <v-list-item-group
        v-model="selectedIdColumns"
        item-height="54px"
        height="432px"
      >
        <v-list-item
          v-for="item in idColumns"
          :key="item.id"
          :value="item.name"
          class="list-item"
        >
          <template v-slot:default="{ active }">
            <v-checkbox :input-value="active"></v-checkbox>
            <v-list-item-content>
              <p class="list-item__name">{{ item.name }}</p>
            </v-list-item-content>
          </template>
        </v-list-item>
      </v-list-item-group>

      <v-list-item-group
        v-model="selectedHoursChangeColumns"
        item-height="54px"
        height="432px"
        class="mt-0"
      >
        <v-list-item
          v-for="item in specialHourColumns"
          :key="item.id"
          :value="item.name"
          ripple
          class="list-item"
        >
          <template v-slot:default="{ active }">
            <v-checkbox :input-value="active"></v-checkbox>
            <v-list-item-content>
              <p class="list-item__name">{{ item.name }}</p>
            </v-list-item-content>
          </template>
        </v-list-item>
      </v-list-item-group>
      <v-list-item-group
        v-model="selectedBasicColumns"
        item-height="54px"
        height="432px"
        multiple
        class="mt-0"
      >
        <v-list-item
          v-for="item in editAllowedColumns"
          :key="item.id"
          :value="item.name"
          ripple
          class="list-item"
        >
          <template v-slot:default="{ active }">
            <v-checkbox :input-value="active"></v-checkbox>
            <v-list-item-content>
              <p class="list-item__name">{{ item.name }}</p>
            </v-list-item-content>
          </template>
        </v-list-item>
      </v-list-item-group>
    </v-list>
    <template #actions>
      <ui-button color="primary" outlined @click="$emit('close')">
        {{ $t("message.common.cancel") }}
      </ui-button>
      <ui-button
        color="primary"
        :disabled="!isValid"
        @click="handleAcceptColumns"
      >
        {{ $t("message.common.further") }}
      </ui-button>
    </template>
  </FileDialogWrapper>
</template>

<script>
import cuid from "cuid";
import FileDialogWrapper from "@/components/BusinessAddresses/FileDialogWrapper";

const ID_COLUMNS = [
  { id: cuid(), name: "id" },
  { id: cuid(), name: "store_code" }
];
const SPECIAL_HOUR_COLUMNS = [
  { id: cuid(), name: "special_hours_add" },
  { id: cuid(), name: "special_hours_replace" }
];
const ALLOWED_COLUMNS = [
  { id: cuid(), name: "name" },
  { id: cuid(), name: "street" },
  { id: cuid(), name: "street_number" },
  { id: cuid(), name: "postal_code" },
  { id: cuid(), name: "city" },
  { id: cuid(), name: "province" },
  { id: cuid(), name: "country" },
  { id: cuid(), name: "opening_hours" },
  { id: cuid(), name: "phone_number" },
  { id: cuid(), name: "phone_number_2" },
  { id: cuid(), name: "website" },
  { id: cuid(), name: "description" }
];

export default {
  name: "SelectColumnsDialogContent",
  components: {
    FileDialogWrapper
  },
  data() {
    return {
      editAllowedColumns: ALLOWED_COLUMNS,
      specialHourColumns: SPECIAL_HOUR_COLUMNS,
      idColumns: ID_COLUMNS,
      selectedBasicColumns: [],
      selectedIdColumns: "",
      selectedHoursChangeColumns: ""
    };
  },
  computed: {
    isValid() {
      const isIdSelected = this.selectedIdColumns;
      const isAnyFieldSelected =
        this.selectedBasicColumns.length > 0 || this.selectedHoursChangeColumns;

      return isIdSelected && isAnyFieldSelected;
    }
  },
  methods: {
    handleAcceptColumns() {
      if (!this.isValid) return;

      const selectedColumns = [
        this.selectedIdColumns,
        ...this.selectedBasicColumns
      ];

      if (this.selectedHoursChangeColumns) {
        selectedColumns.push(this.selectedHoursChangeColumns);
      }

      this.$emit("change", selectedColumns);
    }
  }
};
</script>

<style lang="scss" scoped>
.dialog__actions {
  width: 100%;
  display: flex;
  justify-content: flex-end;
  gap: $spacing * 2;
}
.list-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-right: 0 !important;
  padding-left: $spacing * 1.5;
  width: 100%;
  height: 54px;
  border-bottom: 1px solid $light-3;

  &--top {
    height: 59px;
  }

  &__name {
    @include font-size(14px);
    margin-bottom: 0;
    line-height: 24px;
  }

  .v-list-item__content {
    padding-left: $spacing;
  }

  .v-input--checkbox {
    margin-top: $spacing * 2.5;
  }
}
</style>
